export default "__VITE_ASSET__0a54ab81__"